import { BuildClientPayload } from "@/components/common/types/BuildClientPayload";
import { GET_PATIENT_ADDRESSES_LIST } from "@/components/graphql/address";
import {
  GetPatientAddressList,
  GetPatientAddressListVariables,
} from "@/components/graphql/types/getPatientAddressList";

export default async function fetchPatientAddressListApi(payload: BuildClientPayload & { patientId: string }) {
  const { apolloClient, patientId } = payload;

  return await apolloClient.query<GetPatientAddressList, GetPatientAddressListVariables>({
    query: GET_PATIENT_ADDRESSES_LIST,
    variables: {
      patientId,
    },
    fetchPolicy: "no-cache",
  });
}
